import { useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { TNC_API } from "./apiRoutes";

interface UseGetTncAcceptanceLogsProps {
  userId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getTncAcceptanceLogs = async (userId: string) =>
  await axiosAuth.get(`${TNC_API}/acceptance-logs`, { params: { userId } });

const useGetTncAcceptanceLogs = ({
  userId,
  queryParams,
}: UseGetTncAcceptanceLogsProps): UseQueryResult<any> =>
  useQuery({
    queryKey: ["tnc-acceptance-logs", userId],
    queryFn: () => getTncAcceptanceLogs(userId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });

export default useGetTncAcceptanceLogs;
